<div ngbDropdown display="dynamic" placement="bottom-end">
  <button type="button"
    class="btn d-flex items-container justify-content-between w-100 {{ isDisabled ? 'disabled' : '' }} {{ selectedSelectItemIsNotset()? '': 'with-value' }}"
    ngbDropdownToggle (click)="onOpenDropdown()">
    <span class="text-gray-600" *ngIf="selectedSelectItemIsNotset()">{{ title }}</span>
    <span *ngIf="!selectedSelectItemIsNotset()" class="selected-container">
      <span *ngFor="let item of selectedSelectItems" class="selected">
        <span [innerHTML]="item.name | safe: 'html'"></span>
        <i (click)="onItemClick(item);$event.stopPropagation()" class="bi bi-x fw-bold"></i>
      </span>
    </span>
    <span class="ms-2">
      <app-ac-icon-arrow-down></app-ac-icon-arrow-down>
    </span>
  </button>
  <div ngbDropdownMenu class="w-100">
    <div class="p-2">
      <input (input)="search()" [(ngModel)]="searchKey" #searchElement type="search" name="" class="form-control"
        placeholder="Type to search..." />
    </div>
    <div class="results">
      <button *ngFor="let item of filteredOptions" (click)="onItemClick(item); $event.stopPropagation()"
        [innerHTML]="item.name | safe: 'html' "
        class="btn border-0 btn-lg w-100 {{ selectedSelectItemHasItem(item) ? 'active': '' }}">
      </button>
      <span class="p-3" *ngIf="filteredOptions.length === 0">No results found</span>
    </div>
    <button *ngIf="createNewText" appPermission [permissionArray]="[[createSection, 2]]" ngbDropdownItem
      class="border-top text-primary fw-bold" (click)="createNewClicked()">
      <i class="bi bi-plus-circle me-2"></i> {{ createNewText }}
    </button>
  </div>
</div>
